let buttonPlaceholderText = 'No File Chosen';

export default {
    init() {
        this.customFileTypeButton();
        this.event();
        this.selectStyle();
    },
    event() {      

        $('.hs-fieldtype-file .hs-input').on('change', (e) => {
            let buttonPlaceholder = $(e.currentTarget).closest('.custom-button-label').find('.custom-button-placeholder');
            if (e.currentTarget.files.length) {
                buttonPlaceholder.text(e.currentTarget.files[0].name);
            }
            else {
                buttonPlaceholder.text(buttonPlaceholderText);
            }
        });
    },
    customFileTypeButton() {
        $('.hs-fieldtype-file')
            .find('.hs-input')
            .wrapAll('<label class="custom-button-label" />')
            .after(`<div class="custom-button">Choose File</div><div class="custom-button-placeholder">${buttonPlaceholderText}</div>`);
    },
    selectStyle(){    
        jQuery('.hbspt-form .hs-form .hs-form-field').each(function() {
            if (jQuery(this).find('input,textarea,select').val() != '') {                
                jQuery(this).closest('.hs-form-field').addClass('focus');
            }else {
                    jQuery(this).closest('.hs-form-field').removeClass('focus');
            }
        });
        jQuery('.hbspt-form .hs-form .hs-form-field').each(function(i) {
            i +=1;
            var $this = jQuery(this);						        								        									        											
            jQuery(this).find('.input input').on('blur',function(){
                setTimeout(function(){
                    if($this.find('.hs-error-msgs').length > 0){
                        $this.addClass('hs_error');
                    }
                },350);
            });
            $this.find('.input').children().attr('tabindex', i);
        });
        jQuery('.hbspt-form select').select2({minimumResultsForSearch: -1});
        jQuery('.hbspt-form select').each(function (i, obj) {
            if(jQuery(obj).hasClass('select2-hidden-accessible')){
                var tab2 = jQuery(obj).next('.select2').find('.select2-selection').attr('tabindex');
                jQuery(obj).attr('tabindex',tab2);
                setTimeout(function(){
                    jQuery('.select2-selection').removeAttr('tabindex');
                    jQuery('.select2-container').removeAttr('tabindex');
                },60);
            }
        });
        jQuery('.hbspt-form .hs-form .hs-form-field').on('click', function(event) {
            event.stopPropagation();
            jQuery('.hbspt-form .hs-form .hs-form-field').each(function() {
                var curFiledVal = jQuery(this).find('input,textarea,select').val();
                if (curFiledVal == '') {
                    jQuery(this).removeClass('focus');
                }
            });
            if (jQuery(event.target).find('input,textarea').val() != '') {
                jQuery(event.target).closest('.hs-form-field').addClass('focus');
            } else {
                jQuery(event.target).closest('.hs-form-field').removeClass('focus');
            }
        });
        jQuery('.hbspt-form .hs-form .hs-form-field').on('input', function(event) {
            event.stopPropagation();
            jQuery('.hbspt-form .hs-form .hs-form-field').each(function() {
                var curFiledVal = jQuery(this).find('input,textarea,select').val();
                if (curFiledVal == '') {
                    jQuery(this).removeClass('focus');
                }
            });
            if (jQuery(event.target).find('input,textarea').val() != '') {
                jQuery(event.target).closest('.hs-form-field').addClass('focus');
            } else {
                jQuery(event.target).closest('.hs-form-field').removeClass('focus');
            }
        });
        jQuery(document).click(function() {
            jQuery('.hbspt-form .hs-form .hs-form-field').each(function() {
                if (jQuery(this).find('input,textarea,select').val() != '') {
                    jQuery(this).closest('.hs-form-field').addClass('focus');
                } else {
                    jQuery(this).closest('.hs-form-field').removeClass('focus');
                }
            });
        });
        jQuery('.hbspt-form .hs-form .hs-form-field input, .hbspt-form .hs-form .hs-form-field textarea, .hbspt-form .hs-form .hs-form-field select').bind('keydown', function(e) {
            var key = e.charCode ? e.charCode : e.keyCode ? e.keyCode : 0;
            if (key == 9) {
                var	tabindex = jQuery(this).attr('tabindex');
                tabindex++;
                jQuery('[tabindex=' + tabindex + ']').focus();
                jQuery('.hbspt-form .hs-form .hs-form-field').each(function(){
                    var curFiledVal = jQuery(this).find('input,textarea,select').val();
                    if (curFiledVal == '') {
                        jQuery(this).removeClass('focus');
                    }
                });
                jQuery('[tabindex=' + tabindex + ']').closest('.hs-form-field').addClass('focus');
                jQuery('.select2-selection').removeAttr('tabindex');
                jQuery('.select2-container').removeAttr('tabindex');
                var elSelect = jQuery('[tabindex=' + tabindex + ']');
                if (jQuery('[tabindex=' + tabindex + ']').closest('.hs-form-field').hasClass('hs-fieldtype-select')) {
                    jQuery('select').select2('close');
                    elSelect.select2('open');
                }else{
                    jQuery('select').select2('close');
                }
                return false;
            }
        });
        jQuery('.hbspt-form .hs-form .hs-form-field input, .hbspt-form .hs-form .hs-form-field textarea, .hbspt-form .hs-form .hs-form-field select').keydown(function(e) {
            if (e.shiftKey && e.keyCode == 9) {
                var tabindex = jQuery(this).attr('tabindex');
                tabindex--;
                jQuery('[tabindex=' + tabindex + ']').focus();
                jQuery('.hbspt-form .hs-form .hs-form-field').each(function(){
                    var curFiledVal = jQuery(this).find('input,textarea,select').val();
                    if (curFiledVal == ''){
                        jQuery(this).removeClass('focus');
                    }
                });
                jQuery('[tabindex=' + tabindex + ']').closest('.hs-form-field').addClass('focus');
                jQuery('.select2-selection').removeAttr('tabindex');
                jQuery('.select2-container').removeAttr('tabindex');
                var elSelect = jQuery('[tabindex=' + tabindex + ']');
                if (jQuery('[tabindex=' + tabindex + ']').closest('.hs-form-field').hasClass('hs-fieldtype-select')) {
                    jQuery('select').select2('close');
                    elSelect.select2('open');
                }else{
                    jQuery('select').select2('close');
                }
                return false;
            }
        });
    },
}



// WEBPACK FOOTER //
// ./scripts/components/hubspot_form.js